<aside class="margin-panel">
  <section class="section-margin-panel">
    <div class="section-margin-panel-card">
      <ng-container *ngIf="cards?.length">
        <app-card *ngFor="let card of cards" [card]="card" [headingLevel]="4">
          <ng-container *ngFor="let detail of card.details">
            <p [innerHTML]="detail.formatted | markdown"></p>
          </ng-container>
        </app-card>
      </ng-container>
    </div>
  </section>
</aside>
